import useFilteredShoes from "./FilteredShoes.hook";

export default useFilteredShoes;
